__turbopack_context__.v({
  "profile-dropdown-item": "VU86ZG_profile-dropdown-item",
  "profile-dropdown-item-button": "VU86ZG_profile-dropdown-item-button",
  "profile-dropdown-item-button__icon": "VU86ZG_profile-dropdown-item-button__icon",
  "profile-dropdown-item__icon": "VU86ZG_profile-dropdown-item__icon",
  "profile-dropdown-item__with-divider": "VU86ZG_profile-dropdown-item__with-divider",
});
